import { actions } from '../../../utils/constants';

export const setCredentialsValue = ({ target }) => ({
  type: actions.ASYNC_CREDENTIAL_VALUE, payload: {
    id: target.id,
    value: target.value
  }
})

export const exitFromAdmin = () => ({
  type: actions.ASYNC_CANCEL_CREDENTIALS
})

export const sendCredentials = () => ({
  type: actions.ADMIN_SEND_CREDENTIALS
})

export const addUser = newUser => ({
  type: actions.ASYNC_ADD_COACH,
  payload: newUser
})

export const setCoachFormValue = ({ target }) => ({
  type: actions.SET_COACH_FORM_VALUE, payload: {
    id: target.id,
    value: target.value
  }
})

export const getListUsers = () => ({
  type: actions.ASYNC_GET_USERS
})

export const filterSearch = ({ target }) => ({
  type: actions.SET_ADMIN_SEARCH_VALUE,
  payload: target.value
})

export const removeUser = id => ({
  type: actions.ASYNC_REMOVE_USER,
  payload: id
})

export const goToEditUser = id => ({
  type: actions.ASYNC_GO_TO_EDIT_USER,
  payload: id
})

export const goToAddUser = () => ({
  type: actions.ASYNC_GO_TO_ADD_USER,
})

export const getUserById = id => ({
  type: actions.ASYNC_GET_USER_BY_ID,
  payload: id
})

export const editUser = newUser => ({
  type: actions.ASYNC_EDIT_USER,
  payload: newUser
})






// WEBPACK FOOTER //
// ./src/App/containers/admin/admin.actions.js